import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-controller-details-form',
    templateUrl: './controller-details-form.component.html',
    styleUrls: ['./controller-details-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllerDetailsFormComponent {
    @Input() form!: FormGroup;
    @Input() entity: any;
    @Output() statusChange = new EventEmitter<boolean>();
}
